import React, { FunctionComponent } from "react";
import classNames from "classnames/bind";

import { MaxWidthContainerProps } from "./MaxWidthContainer.types";
import styles from "./MaxWidthContainer.module.scss";

const cx = classNames.bind(styles);

export const MaxWidthContainer: FunctionComponent<MaxWidthContainerProps> = ({
    children,
    className,
}) => <div className={cx(className, "root")}>{children}</div>;
